import { useEffect } from "react";
import config from "../../devprodConfig";

export default function useEnsureEnergiaTable(propertyId) {
  useEffect(() => {
    if (!propertyId) return;

    const ensureExists = async () => {
      try {
        const res = await fetch(
          `${config.apiBaseUrl}/api/energia_tables/by/id_kiinteisto/${propertyId}`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("Energia fetch failed:", res.status);
          return;
        }

        const rows = await res.json();

        if (Array.isArray(rows) && rows.length > 0) {
          return; // already exists
        }

        const defaultData = {
          blocks: [
            {
              title: "Lämmitysenergia",
              columns: [
                "Vuosi",
                "Mitattu kokonaiskulutus MWh",
                "Normeerattu kokonaiskulutus MWh",
                "Ominaiskulutus kWh/m³",
                "Ominaiskulutuksen vertailuarvo kWh/m³",
                "Erotus",
              ],
              rows: [],
              summary: "",
            },
            {
              title: "Vesi",
              columns: [
                "Vuosi",
                "Mitattu kokonaiskulutus m³",
                "Ominaiskulutus l / hlö / vrk",
                "Ominaiskulutuksen vertailuarvo l / hlö / vrk",
                "Erotus",
              ],
              rows: [],
              summary: "",
            },
            {
              title: "Kiinteistösähkö",
              columns: [
                "Vuosi",
                "Mitattu kokonaiskulutus MWh",
                "Ominaiskulutus kWh/m³",
                "Ominaiskulutuksen vertailuarvo kWh/m³",
                "Erotus",
              ],
              rows: [],
              summary: "",
            },
          ],
        };

        await fetch(`${config.apiBaseUrl}/api/energia_tables`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id_kiinteisto: propertyId,
            data: defaultData,
          }),
          credentials: "include",
        });

        console.log("✅ Energia table auto-created");
      } catch (err) {
        console.error("Energia ensure failed:", err);
      }
    };

    ensureExists();
  }, [propertyId]);
}